import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getNonBankEarningsQualityThunk = createAsyncThunk(
  'financialAnalysis/NonBank/getBankEarningsQuality',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getEarningsQuality(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadNonBankEarningsQuality = createAsyncThunk(
  'financialAnalysis/NonBank/downloadBankEarningsQuality',
  async (data) => {
    const response = await FinancialAnalysisService.downloadEarningsQuality(
      data,
    )
    handleExport(response.data, response.filename)
  },
)
